import React, { useState } from "react";
import {
  List,
  useTable,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const BingxTradeList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_subscription_id",
        title: "Bot-subscription Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 250,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "order_id",
        title: "Order Id",
        width: 170,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "filled_tm",
        title: "Filled Tm",
        width: 200,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "volume",
        title: "Volume",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "price",
        title: "Price",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "amount",
        title: "Amount",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "commission",
        title: "Commission",
        type: "number",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "currency",
        title: "Currency",
        width: 80,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "liquidated_price",
        title: "Liquidated price",
        type: "number",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "liquidated_margin_ratio",
        title: "Liquidated margin ratio",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "symbol",
        title: "Symbol",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "side",
        title: "Side",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "type",
        title: "Type",
        width: 80,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "position_side",
        title: "Position side",
        width: 120,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "cum_quote",
        title: "Cum quote",
        width: 120,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "status",
        title: "Status",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "stop_price",
        title: "Stop price",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "orig_qty",
        title: "Orig qty",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "avg_price",
        title: "Avg price",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "executed_qty",
        title: "Executed qty",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "profit",
        title: "Profit",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "update_time",
        title: "Update time",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "client_order_id",
        title: "Client order id",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" color="success" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey={(row) => `${row.trade_id}-${row.filled_tm}`}
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
